/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Report_Sent_SuccessInputs */

const en_mobile_report_sent_success = /** @type {(inputs: Mobile_Report_Sent_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report sent successfully`)
};

const es_mobile_report_sent_success = /** @type {(inputs: Mobile_Report_Sent_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporte enviado correctamente`)
};

/**
* | output |
* | --- |
* | "Report sent successfully" |
*
* @param {Mobile_Report_Sent_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_report_sent_success = /** @type {((inputs?: Mobile_Report_Sent_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Report_Sent_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_report_sent_success(inputs)
	return en_mobile_report_sent_success(inputs)
});